import { Box, Divider, Typography } from "@mui/material"
import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import type { Control, FieldArrayWithId } from "react-hook-form"
import { useFieldArray } from "react-hook-form"

import {
  ATYPICAL_SURCHARGE_TYPE_OPTIONS,
  BLANK_PRODUCT_ATYPICAL_SURCHARGE_ITEM,
  COST_BREAKDOWN_CURRENCY_FIELD_PROPS,
} from "../../constants"

import { Button } from "@/components/common/Button"
import { FormNumericField, FormSelect, FormTextField } from "@/components/UiKit/FormControls"

interface AtypicalSurchargesFormGroupProps {
  control: Control<any>
  baseFieldPath: string
  productIndex: number
}

export const AtypicalSurchargesFormGroup: FC<AtypicalSurchargesFormGroupProps> = ({
  control,
  baseFieldPath,
  productIndex,
}) => {
  const { fields: atypicalSurchargeFields, append: appendAtypicalSurcharge } = useFieldArray({
    control,
    name: baseFieldPath,
  })

  return (
    <Box className='mt-14'>
      <Box className='mb-2'>
        <Typography variant='h6' className='text-sm font-medium text-gray-700'>
          Atypical Surcharge
        </Typography>
      </Box>
      <Divider className='mb-4' />

      <Box className='space-y-4'>
        {atypicalSurchargeFields.map((field: FieldArrayWithId, surchargeIndex: number) => (
          <Box key={field.id} className='grid grid-cols-3 gap-6'>
            <FormSelect
              control={control}
              name={`${baseFieldPath}.${surchargeIndex}.type`}
              label='Type'
              options={ATYPICAL_SURCHARGE_TYPE_OPTIONS}
              placeholder='Select One'
              data-testid={`product-${productIndex}-atypical-surcharge-${surchargeIndex}-type-select`}
            />

            <FormNumericField
              control={control}
              name={`${baseFieldPath}.${surchargeIndex}.amount`}
              label='Amount'
              {...COST_BREAKDOWN_CURRENCY_FIELD_PROPS}
              data-testid={`product-${productIndex}-atypical-surcharge-${surchargeIndex}-amount-input`}
            />

            <FormTextField
              control={control}
              name={`${baseFieldPath}.${surchargeIndex}.description`}
              label='Description'
              placeholder='Description'
              data-testid={`product-${productIndex}-atypical-surcharge-${surchargeIndex}-description-input`}
            />
          </Box>
        ))}
      </Box>
      <Box className='flex justify-end pt-2'>
        <Button
          appearance='text'
          size='small'
          startIcon={<AddOutlined />}
          onClick={() => appendAtypicalSurcharge(BLANK_PRODUCT_ATYPICAL_SURCHARGE_ITEM)}
          data-testid={`product-${productIndex}-add-atypical-surcharge-button`}
        >
          Additional Surcharge
        </Button>
      </Box>
    </Box>
  )
}
